import React from "react";
import SideBarSimilarProfileItem from "./SideBarSimilarProfileItem";
import SideBarTitle from "./SideBarTitle";

const SideBarSimilarProfiles = ({ similarProfiles }) => {
  return (
    <div>
      <SideBarTitle title="Profiles with similar interests" />
      <div>
        {similarProfiles.map((profile, key) => (
          <SideBarSimilarProfileItem
            key={key}
            name={`${profile.firstName} ${profile.lastName}`}
            username={profile.loginName}
            // TODO: jobTitle is missing in the current response.Check later if it's available
            jobTitle={profile.jobTitle}
            profileImage={profile.profileImage}
            userId={profile.userId}
          />
        ))}
      </div>
    </div>
  );
};

export default SideBarSimilarProfiles;
